import { inject, Injectable } from '@angular/core';
import { WorldCupRepository } from '@data/repositories/world-cup.repository';
import { UseCaseGet } from '@shared/helper';
import { GetWorldCupScheduleResp } from './get-world-cup-schedule.type';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GetWorldCupScheduleUsecase implements UseCaseGet<GetWorldCupScheduleResp> {
    worlCupRepository = inject(WorldCupRepository);

    execute(): Observable<GetWorldCupScheduleResp> {
        return this.worlCupRepository.GetWorldCupSchedule();
    }
}